import instance from "../../axios/axios-user";
import { API_PATHS } from "../api_paths";

type getEntityInfoProps = { id: string; type: string };
const getEntityInfo = ({ id, type }: getEntityInfoProps) =>
  instance(`${API_PATHS.info.getEntityInfo}/${type}/${id}`);

export const INFO = { getEntityInfo };
